import { cn } from "@omni/utils/styles";

import { AdditionalServiceModel } from "@/types/service/shared";

import { useDeliveryItemContext } from "../../context/deliveryItem.context";
import { AdditionalServiceItem } from "./additionalServiceItem.container";

const AdditionalServicesComponent = () => {
    const {
        montages,
        checked,
        serviceProductTooltipItem,
        activeServiceProducts,
        onChangeServiceProduct
    } = useDeliveryItemContext();

    const onServiceProductClick = (serviceProduct: AdditionalServiceModel) =>
        onChangeServiceProduct(serviceProduct);

    return (
        <div className={cn("tw:pl-5.25")}>
            {montages?.map((serviceProduct) => (
                <AdditionalServiceItem
                    key={serviceProduct.sku}
                    serviceProduct={serviceProduct}
                    onServiceProductClick={onServiceProductClick}
                    activeServiceProducts={
                        checked ? activeServiceProducts || [] : []
                    }
                    tooltip={serviceProductTooltipItem}
                    documents={serviceProduct.documents}
                />
            ))}
        </div>
    );
};

export { AdditionalServicesComponent };
